import { Component, computed, OnDestroy, signal, inject } from '@angular/core';
import { EmployeeIdentityDocumentStatus } from '../../../_interfaces/employee.interface';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../store/app/app.selectors';
import { Subscription } from 'rxjs';
import { idStatus } from '../../utils/general-utils';
import { helpCenterUrl } from '../../../_fixtures/project-fixtures';

@Component({
  selector: 'app-alert-kyc-status',
  templateUrl: './alert-kyc-status.component.html',
  imports: [RouterLink],
})
export class AlertKycStatusComponent implements OnDestroy {
  readonly store = inject(Store);
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  private readonly subscriptions = new Subscription();
  protected readonly idStatus = idStatus;
  readonly helpCenterUrl = helpCenterUrl;
  status = signal<EmployeeIdentityDocumentStatus | null>(null);
  isSubCardHolder = signal<boolean | undefined>(undefined);
  needsAction = computed(() => {
    // Employees complete KYC on app, this is just for admins.
    // Admin with an employee card will also complete KYC on app.
    // This only caters for admins who have a subscription card that is not KYC verified
    return (
      this.isSubCardHolder() &&
      (this.idStatus(this.status()).isRejected ||
        this.idStatus(this.status()).isError ||
        this.idStatus(this.status()).isNull)
    );
  });

  constructor() {
    this.subscriptions.add(
      this.userProfile$.subscribe({
        next: (data) => {
          if (data) {
            this.status.set(data?.idnum_status);
            this.isSubCardHolder.set(data?.is_subscription_card_holder);
          }
        },
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
